import { fetchAllSentEmailData } from '../../database/fetch-sent-email-data';

const getSentEmails = (callback) => {
  const unsubscribe = fetchAllSentEmailData((emails) => {
    const formattedData = emails.map((email, index) => ({
      ...email,
      id: email.docId,
      no: index + 1,
      subject: email.subject || '',
      body: email.body || '',
      to: Array.isArray(email.to) ? email.to.join(', ') : (email.to || ''),
      from: email.from || '',
      dateTime: email.dateTime || '',
      attachments: Array.isArray(email.attachments) ? email.attachments.length : 0,
      attachmentsArray: Array.isArray(email.attachments) ? email.attachments : [],
      emailType: email.emailType || '',
      data: email,
    }));
    callback(formattedData);
  });
  return unsubscribe;
};

export default getSentEmails; 